export default "__VITE_ASSET__TFKa533W__"